import * as ko from 'knockout';

// Toggles can-scroll-left/can-scroll-right classes on the element based on the
// horizontal scroll state of its first element child (the scrollable
// container), so CSS can render edge shadows hinting at off-screen content.
// The classes live on the wrapper because overlays positioned on the scroll
// container itself would scroll along with the content.
ko.bindingHandlers['horizontalScrollHints'] = {
  init: (element: HTMLElement) => {
    const container = element.firstElementChild;
    if (!(container instanceof HTMLElement)) {
      return;
    }

    const update = () => {
      element.classList.toggle('can-scroll-left', container.scrollLeft > 0);
      element.classList.toggle(
        'can-scroll-right',
        container.scrollLeft + container.clientWidth < container.scrollWidth - 1
      );
    };

    container.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    // re-rendered content (pagination, filtering) changes the scroll width
    const observer = new MutationObserver(update);
    observer.observe(container, { childList: true, subtree: true });
    update();

    ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
      container.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      observer.disconnect();
    });
  },
};
